export default __webpack_public_path__ + "static/media/0xdda40cdfe4a0090f42ff49f264a831402adb801a.bab920a7.webp";